import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import SuccessView from "@/views/SuccessView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/success",
    name: "SuccessView",
    component: SuccessView,
  },
  {
    path: "/Contactus",
    name: "contact_us",
    component: () => import("@/views/ContactUs.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/LoginCellule.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    component: () => import("@/views/PnF.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
